import React from "react";
import { observer } from "mobx-react";

// Translations
import translate from "../Translate.js";

// Components
import * as icons from "../Icons/Icons";
import { checkValidity } from "../../helpers/helpers.js";

const SeatSettings = observer(
  class SeatSettings extends React.Component {
    state = {
      seatName: "",
      seatDescription: "",
      autoAssign: true,
      priority: null,
      calendars: this.props.calendars.map(calendar => calendar.sid),
    };

    componentWillMount() {
      const { seats, seatSid } = this.props;

      if (seatSid) {
        // I know this is gross but this is the only way that I know to create a deep copy of an object.
        // Before using the JSON methods this would update the seat view in the background while
        // changing settings before saving your choices
        const seat = JSON.parse(JSON.stringify(seats.find((seat) => seat.sid === seatSid)));

        this.setState({
          seatName: seat.title,
          seatDescription: seat.description,
          autoAssign: seat.autoAssign,
          priority: seat.autoAssignPriority,
          calendars: seat.calendarSids,
        });
      }
    }

    handleAssociatedCalendar(calendarSid) {
      const index = this.state.calendars.findIndex(
        (calendar) => calendar === calendarSid
      );

      if (index === -1) {
        this.setState({ calendars: [...this.state.calendars, calendarSid] });
      } else {
        const newArr = this.state.calendars;
        newArr.splice(index, 1);

        this.setState({ calendars: newArr });
      }
    }

    handlePriority(e) {
      if (e.target.value > 999) {
        e.target.value = 999;
      }

      const priority = parseInt(e.target.value, 10);

      if (isNaN(priority)) {
        this.setState({ priority: null });
      } else {
        this.setState({ priority });
      }
    }

    handleSubmit(e, closeSettings) {
      e.preventDefault();
      const { seatName, seatDescription, autoAssign, priority, calendars } =
        this.state;
      const { close, seatSid, store } = this.props;
      const { ScheduleStore } = store;

      const payload = {
        title: seatName,
        description: seatDescription,
        autoAssign,
        autoAssignPriority: priority || null,
        calendarSids: calendars,
      };

      if (seatSid) {
        ScheduleStore.updateSeat(payload, seatSid, close);
      } else {
        const callback = () => {
          this.setState({
            seatName: "",
            seatDescription: "",
            autoAssign: true,
            priority: '',
            calendars: [],
          });

          if (!closeSettings) {
            document.getElementById("seat-settings-form").reset();

            // Auto assign should be on by default
            document.getElementById("auto-assign").click();
            this.setState({autoAssign: true});
          }
        };

        ScheduleStore.addSeat(payload, callback);
      }

      if (closeSettings) {
        close();
      }
    }

    render() {
      const { seatSid, close, calendars, translation } = this.props;
      return (
        <div className="dialog">
          <div className="dialog__content">
            <strong className="dialog__msg">
              {seatSid ? translation.edit : translation.add}
            </strong>
            <button className="panel__close panel__close-alt" onClick={close}>
              <icons.iconTimes />
              <span className="meta">{translation.cancel}</span>
            </button>

            <form
              onSubmit={(e) => checkValidity(e, this.handleSubmit)}
              id="seat-settings-form"
            >
              <fieldset>
                <ul className="fields">
                  <li className="field--full">
                    <label className="lbl-required" htmlFor="seat-name">
                      {translation.name}
                    </label>

                    <input
                      id="seat-name"
                      type="text"
                      onChange={(e) =>
                        this.setState({ seatName: e.target.value })
                      }
                      defaultValue={this.state.seatName}
                      required
                      aria-required="true"
                    />
                  </li>
                  <li className="field--full">
                    <label htmlFor="seat-description">{translation.description}</label>

                    <input
                      id="seat-description"
                      type="text"
                      onChange={(e) =>
                        this.setState({ seatDescription: e.target.value })
                      }
                      defaultValue={this.state.seatDescription}
                    />
                  </li>
                  <li className="field--full">
                    <label className="switch-label--alt" htmlFor="auto-assign">
                      {translation.auto_assign}
                    </label>
                    <input
                      type="checkbox"
                      id="auto-assign"
                      className="switch-input"
                      value={this.state.autoAssign}
                      defaultChecked={this.state.autoAssign}
                      onChange={() =>
                        this.setState({ autoAssign: !this.state.autoAssign })
                      }
                    />

                    <label className="switch-label" htmlFor="auto-assign">
                      <span className="meta">Auto Assign</span>
                    </label>
                    {this.state.autoAssign && (
                      <div>
                        <label htmlFor="priority">{translation.priority}</label>
                        <input
                          id="priority"
                          type="number"
                          value={this.state.priority || ''}
                          min="1"
                          max="999"
                          onChange={(e) => this.handlePriority(e)}
                        />
                      </div>
                    )}
                  </li>
                  <li className="field--full">
                    <h4>{translation.calendars}</h4>
                    {calendars.length === 0 &&
                      <p>{translation.no_results}</p>
                    }
                    {calendars.length > 0 &&
                      calendars.map((calendar, i) => (
                        <div key={`calender-${i}`}>
                          <input
                            type="checkbox"
                            id={`calender-${calendar.sid}`}
                            className="switch-input"
                            value={this.state.calendars.some(
                              (calendarSid) => calendar.sid === calendarSid
                            ) || !this.props.seatSid}
                            defaultChecked={this.state.calendars.some(
                              (calendarSid) => calendar.sid === calendarSid
                            ) || !this.props.seatSid}
                            onChange={() =>
                              this.handleAssociatedCalendar(calendar.sid)
                            }
                          />

                          <label
                            className="switch-label"
                            htmlFor={`calender-${calendar.sid}`}
                          >
                            <span className="meta">{calendar.title}</span>
                          </label>
                          <label
                            className="switch-label--alt"
                            htmlFor={`calender-${calendar.sid}`}
                          >
                            {calendar.title || `Calendar ${i}`}
                          </label>
                        </div>
                      ))}
                  </li>
                </ul>

                {!this.props.seatSid && (
                  <div className="btn-group">
                    <button
                      className="btn"
                      onClick={(e) => this.handleSubmit(e, true)}
                    >
                      {translation.save}
                    </button>
                    <button
                      className="btn"
                      onClick={(e) => this.handleSubmit(e, false)}
                    >
                      {translation.save}{translation.new}
                    </button>
                  </div>
                )}

                {this.props.seatSid && (
                  <button
                    className="btn"
                    onClick={(e) => this.handleSubmit(e, true)}
                  >
                    {translation.save}
                  </button>
                )}
              </fieldset>
            </form>
          </div>
        </div>
      );
    }
  }
);

export default translate('SeatSettings')(SeatSettings);



// WEBPACK FOOTER //
// ./src/app/components/Schedule/SeatSettings.js